import React, { useState } from 'react';
import { Popup } from '../../components/Popup';
import { Button } from '../../components/Button';
import { useDispatch } from 'react-redux';
import { createOfficeRevenue } from '../../redux/officeSlice';
import { Input } from '../../components/Input';

export const CreateRevenue = ({closeFn, city, monthStamp }) => {

    const dispatch = useDispatch();

    const [amount, setAmount] = useState('');
    const [comment, setComment] = useState('');

    const createRevenueHandler = () => {
        if (!amount || isNaN(+amount) || +amount <= 0 || !comment) return;
        dispatch(createOfficeRevenue({amount: +amount, city, monthStamp, comment}));
        closeFn();
    }

    return (
        <Popup
            title='Добавить доход'
            closeFn={closeFn}
            button={<Button text={`Добавить`} onClick={createRevenueHandler} />}>
            <div className='office__create-expense'>
                <Input label='Сумма' value={amount} changeHandler={(evt) => setAmount(evt.target.value)}/>
                <Input label='Коммент' placeholder='обязательное поле' value={comment} changeHandler={(evt) => setComment(evt.target.value)}/>
            </div>
        </Popup>
    );
};
